import { CardLanguageProvider } from '../../components/chat/order-card/CardLanguage';
import {
  type SessionOutfitSelection,
  type SessionTimelineEntry,
} from '../../services/api/sessions';

import { findLatestAssistantSequence, mapPrecedingUserMessages } from './timeline-content';
import { TimelineMessage } from './TimelineMessage';
import { TimelineOutfitSelections } from './TimelineOutfitSelections';

interface Props {
  timeline: SessionTimelineEntry[];
  outfitSelections: SessionOutfitSelection[];
  totalPrice?: number;
  currency?: string;
  sessionId: string;
  canFlag: boolean;
  language: string;
}

export const SessionTimeline = ({
  timeline,
  outfitSelections,
  totalPrice,
  currency,
  sessionId,
  canFlag,
  language,
}: Props) => {
  const latestAssistantSequence = findLatestAssistantSequence(timeline);
  const precedingUserBySequence = mapPrecedingUserMessages(timeline);

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
      <div className="mb-4">
        <h4 className="text-sm font-semibold text-slate-900">Konversation</h4>
        <p className="text-xs text-slate-500">Visar användarens frågor och AI:ns svar.</p>
      </div>

      <CardLanguageProvider language={language}>
      <div className="space-y-4">
        {timeline.length === 0 ? (
          <div className="rounded-lg border border-dashed border-slate-300 bg-white p-6 text-center text-sm text-slate-500">
            Ingen konversationshistorik sparad för sessionen.
          </div>
        ) : (
          timeline.map((entry) => (
            <TimelineMessage
              key={entry.sequence}
              entry={entry}
              sessionId={sessionId}
              canFlag={canFlag}
              precedingUserMessage={precedingUserBySequence.get(entry.sequence) ?? ''}
              language={language}
              footer={
                entry.role === 'assistant' && entry.sequence === latestAssistantSequence ? (
                  <TimelineOutfitSelections
                    selections={outfitSelections}
                    totalPrice={totalPrice}
                    currency={currency}
                  />
                ) : undefined
              }
            />
          ))
        )}
      </div>
      </CardLanguageProvider>
    </div>
  );
};
